import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SecurityEscalation() {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "1000",
    as: "div",
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "column",
      justify: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(Illustration, {
        "data-test-id": "security-illustration",
        name: "account-security",
        width: "33%"
      }), /*#__PURE__*/_jsx(Link, {
        "data-test-id": "security-wiki-link",
        external: true,
        href: "https://wiki.hubspotcentral.net/display/HSR/How+to+Work+with+the+Security+Team",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.escalations.security.label"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "security-wiki-message",
          message: "app.escalations.security.description"
        })
      })]
    })
  });
}
export default /*#__PURE__*/memo(SecurityEscalation);